import { ConfigurationContext } from '@kirz/mui-admin';
import { useContext } from 'react';

export function useClientFormPreSubmit(
  onExistingClient: (client: any) => void,
  type: 'individual' | 'legal',
): any {
  const { hasura } = useContext(ConfigurationContext);

  return async ({ phone, email, ...item }: any) => {
    const [client] = await hasura.request({
      source: 'client',
      selection: 'id fullName',
      where: {
        phones: {
          phone: { _eq: phone },
        },
      },
      limit: 1,
    });

    if (client) {
      onExistingClient({ ...client, phone });
      return null;
    }

    return {
      ...item,
      phones: {
        data: [{ phone, isFavourite: true }],
      },
      ...(email && {
        emails: {
          data: [{ email, isFavourite: true }],
        },
      }),
      type: type ?? 'individual',
    };
  };
}
